export const PAGINATION_VALUES = {
  DEFAULT_PAGE_SIZE: 50,
  DEFAULT_PAGE_NUMBER: 1,
};

export const DEFAULT_LANGUAGE_CODE = 'en';
export const DEFAULT_LANGUAGE_FULL_CODE = 'en-US';
export const demoGraphicValue = {
  RACE: ['Black', 'White', 'Asian', 'Hispanic'],
};

export const demoGraphicCategory = {
  GENDER: 'Gender',
  RACE: 'Race',
};

export const wageType = {
  Annual: 'Annual',
  Hourly: 'Hourly',
};

export const Quartile = {
  val: 'quartile',
  pay: 'Pay',
};

export const apiMappingValues = {
  F: 'F',
  M: 'M',
  O: 'O',
  All: 'ALL',
  Both: 'Both',
  Black: 'Black',
  White: 'White',
  Asian: 'Asian',
  Hispanic: 'Hispanic',
};

export const quartiles = {
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4',
};

export const numericAndDotAndDashRegex = /[^0-9.-]/g;

export const defaultHeaderWidth = {
  defaultCheckboxWidth: 48,
  totalWidthPercentage: 100,
};

export const defaultExcelDateFormat = 'MMMM D YYYY';

export const totalBreakDownFileInfo = {
  fileName: 'Total Remediation Cost Breakdown.xlsx',
  sheetName: 'TR Cost Breakdown',
};

export const totalBreakDownTableInfo = {
  year1: 'Year 1',
};

export const headerIDS = {
  PROPOSED_PAY_ADJUSTMENT: 'proposed_pay_adjustment',
  ADJUSTED_PAY_GAP: 'adjusted_pay_gap',
};

export const REFRESH_AUTH_TOKEN_INTERVEL = 10; // 10in mins
export const IDLE_TIME = 15; //15min
export const IDLE_TIME_LEFT = 5; //5

export const PGCGTags = {
  PEER_GROUPS: 'Peer Groups',
  CUSTOM_GRADES: 'Custom Grades',
};
